import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

import Prefix from '../components/public/Prefix.vue';
import LoginDoctor from '../components/public/LoginDoctor.vue';
import Recovery from '../components/public/Recovery.vue';
import Logout from '../components/Logout.vue';
import RegisterDoctor from '../components/public/RegisterDoctor.vue';

import BidBoxDoctor from '../components/doctor/BoxesOfrecer/Index.vue';

import NotFound from '../components/errors/404.vue';
import DoctorLayout from '../components/doctor/partials/Layout.vue';
import ProfileDoctor from '../components/doctor/ProfileDoctor.vue';
import AskBoxDoctor from '../components/doctor/BoxesSolicitud/Index.vue';

import Validate from '../components/doctor/Validate.vue';
import BidAdd from '../components/doctor/Bid/Add.vue';
import Doctor from '../components/doctor/Subordinate/Doctor.vue';
import Demo from '../components/public/Demo.vue';
import { doctor } from '../config/api.js';
import { prefix } from '../config/api';

export default new VueRouter({
    mode: 'history', // disabled hastag "#" on routes
    routes: [
        {
            // only routes with countries
            path: '/:country',
            component: Prefix,
            children: [
                {
                    // Route register doctor
                    path: doctor.register,
                    name: 'register.doctor',
                    component: RegisterDoctor,
                    meta: {
                        name: 'Registro'
                    }
                },
                {
                    // Route register doctor
                    path: "bidbox",
                    name: 'bidbox',
                    component: BidBoxDoctor,
                    meta: {
                        name: 'Ofertar BOX'
                    }
                },
                {
                    // Route login doctor
                    path: '/',
                    name: 'login.doctor',
                    component: LoginDoctor,
                    meta: {
                        forVisitors: true,
                        name: 'Inicio Sesión'
                    }
                },
                {
                    // Route login doctor
                    path: 'recovery',
                    name: 'recovery.doctor',
                    component: Recovery,
                    meta: {
                        forVisitors: true,
                        name: 'Recuperar Contraseña'
                    }
                },
                {
                    // Route logout
                    path: 'logout',
                    name: 'logout',
                    component: Logout,
                    meta: {
                        requiresAuth: true,
                        name: 'Logout'
                    }
                },
                {
                    // Route demo
                    path: 'demo',
                    component: Demo,
                    name: 'demo',
                    meta: {
                        name: 'Demo'
                    }
                },
                {
                    // Route dashbaord - need authentication
                    path: '/',
                    name: 'dashboard.layout',
                    component: DoctorLayout,
                    meta: {
                        requiresAuth: true
                    },
                    children: [

                        { path: 'askbox', name:'askbox', component: AskBoxDoctor, meta: { name: 'Solicitar BOX' }},

                        { path: 'bidbox_internal', name:'bidbox_internal', component: BidBoxDoctor, meta: { name: 'Ofrecer BOX' }},

                        { path: 'profile', name:'profile', component: ProfileDoctor, meta: { name: 'Mi Perfil' }},
                    ]
                },
                {
                    // Route doctor for user subordinate
                    path: 'doctor',
                    component: Doctor,
                    name: 'Doctor',
                    meta: {
                        name: 'Seleccionar Prestador'
                    }
                },
                {
                    // Route 404
                    path: '*',
                    name: 'notfound',
                    component: NotFound,
                    meta: {
                        name: 'Not Found'
                    }
                }
            ],
            meta: {
                prefix: true
            }
        },
        {
            // redirect prefix "cl" by default
            path: '/',
            redirect: '/' + prefix[0]
        }
    ]
});



// WEBPACK FOOTER //
// ./src/router/index.js